<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="我的订单"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <van-tabs
        sticky
        @click="onClick"
        scroll="{ scrollTop: 64, isFixed: true }"
      >
        <van-tab title="全部">
          <allOrder v-if="active == 0" orderStyle="0" />
        </van-tab>
        <van-tab title="待付款">
          <allOrder v-if="active == 1" orderStyle="10" />
        </van-tab>
        <van-tab title="待签署合同">
          <allOrder v-if="active == 2" orderStyle="20" />
        </van-tab>
        <van-tab title="待发货">
          <allOrder v-if="active == 3" orderStyle="28" />
        </van-tab>
        <van-tab title="待收货">
          <allOrder v-if="active == 4" orderStyle="30" />
        </van-tab>
        <van-tab title="售后">
          <refundList v-if="active == 5" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import allOrder from "./allOrder.vue";
import refundList from "./refundList.vue";
export default {
  components: {
    navbar,
    allOrder,
    refundList,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      active: 0,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onClick(name) {
      this.active = name;
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding-top: 8.8rem;
    box-sizing: border-box;
    height: 100%;

    /deep/.van-tabs {
      min-height: 100%;

      .van-sticky {
        position: fixed;
        top: 8.8rem;
        width: 100%;
        z-index: 2;

        .van-tab {
          font-size: 1.5rem;
          color: #555;
          font-weight: 400;
          padding: 0 0.8rem;
        }

        .van-tab--active {
          color: #f9591b;
        }

        .van-tabs__line {
          background-color: #f9591b;
          height: 0.2rem;
          width: 3rem;
        }
      }
    }
  }
}
</style>




